import styled from 'styled-components';

export const TermsOfServiceContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: #333;

  h1 {
    color: #2c3e50;
    margin-bottom: 30px;
    font-size: 2.2em;
    text-align: center;
  }

  h2 {
    color: #34495e;
    margin-top: 30px;
    margin-bottom: 15px;
    font-size: 1.5em;
    border-left: 4px solid #667eea;
    padding-left: 15px;
  }

  h3 {
    color: #2c3e50;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.2em;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  ul, ol {
    margin-bottom: 15px;
    padding-left: 30px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #667eea;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    margin: 10px;
    padding: 15px;

    h1 {
      font-size: 1.8em;
    }
  }
`;

export const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
`;

export const Logo = styled.div`
  font-size: 2.5em;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2em;
  }
`;

export const Tagline = styled.div`
  color: #666;
  font-style: italic;
  font-size: 1.1em;
`;

export const SectionContainer = styled.div`
  margin-bottom: 30px;
`;

export const SectionTitle = styled.h2`
  color: #34495e;
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 1.5em;
  border-left: 4px solid #667eea;
  padding-left: 15px;
`;

export const SectionContent = styled.div`
  h3 {
    color: #2c3e50;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.2em;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  ul, ol {
    margin-bottom: 15px;
    padding-left: 30px;
  }

  li {
    margin-bottom: 8px;
  }
`;

export const HighlightContainer = styled.div`
  background: #f8f9fa;
  padding: 15px;
  border-left: 4px solid #667eea;
  margin: 20px 0;
  border-radius: 0 5px 5px 0;

  h3 {
    color: #2c3e50;
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 1.2em;
  }

  p {
    margin-bottom: 10px;
    text-align: justify;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const WarningContainer = styled.div`
  background: #fff3cd;
  padding: 15px;
  border-left: 4px solid #ffc107;
  margin: 20px 0;
  border-radius: 0 5px 5px 0;

  p {
    margin-bottom: 10px;
    text-align: justify;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 10px;
    padding-left: 30px;
  }

  li {
    margin-bottom: 8px;
  }
`;

export const ImportantContainer = styled.div`
  background: #f8d7da;
  padding: 15px;
  border-left: 4px solid #dc3545;
  margin: 20px 0;
  border-radius: 0 5px 5px 0;

  p {
    margin-bottom: 10px;
    text-align: justify;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const ContactContainer = styled.div`
  background: #e8f4fd;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
  border: 1px solid #b3d9ff;

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 15px;
    padding-left: 30px;
  }

  li {
    margin-bottom: 8px;
  }
`;
